import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-user-detail',
  templateUrl: './app-user-detail.component.html',
  styleUrls: ['./app-user-detail.component.css']
})
export class AppUserDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
